import React from 'react'
import styles from './PlayerNamesMissingError.module.css'

export default () => (
  <div className={styles.container}>
    Please fill your nickname
  </div>
)
